import React, { useEffect, useState } from "react";
import styles from "./TourList.module.css";
import Header from "./../../components/common/header/Header";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TourListCard from "./../../components/tour-list-card/TourListCard";
import TourListHeader from "./../../components/tour-list-header/TourListHeader";
import TourListFilter from "./../../components/tour-list-filter/TourListFilter";
import { useAppStore } from "../../hooks/store/useAppStore";
import { toursSelector, tourFilterSelector } from "../../hooks/store/getters";
//import dataDB from "../../data/db.json";
import { getAllToursByAccess } from "../../services/TourService";
import { setToursSelector } from "../../hooks/store/setters";
import MapView from "../../components/map-container/MapView";
import { setLoaderSelector } from "../../hooks/store/setters";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getMyTours } from "../../services/TourService";
import { userSelector } from "../../hooks/store/getters";
import { setAlertMessageSelector } from "../../hooks/store/setters";


const TourList = () => {
  const tours = useAppStore(toursSelector);
  const setToursList = useAppStore(setToursSelector);
  const tourFilter = useAppStore(tourFilterSelector);
  const [filterData, setFilterData] = useState([]);
  const [mapView, setMapView] = useState(false);
  const setLoader = useAppStore(setLoaderSelector);
  const user = useAppStore(userSelector);
  const setAlertMessage = useAppStore(setAlertMessageSelector);
  const { type } = useParams();

  
  const tourText = type === 'my-tours'? "My Tours" : "View Tours";
  const tourDescription = type === 'my-tours'? "Manage your tours and scenes" : "Explore the collection of tours";


  useEffect(() => {
    
    const getTours = async () => {
      setLoader("Loading...");
      try {

        if(type === 'my-tours'){
          const data = await getMyTours(user);
          setToursList(data);
        } else if( type === 'all-tours'){
          const data = await getAllToursByAccess(user);  
          setToursList(data);
        }
      } catch(error) {
        setAlertMessage("Error while loading tours");
      }
      
      setLoader("");
    };
    
    getTours();
    // eslint-disable-next-line
  }, [setToursList, user]);

  useEffect(() => {
    const updateFilter = (data) => {
      
      const filter = data.filter(
        (d) => d.info.tourName.toLowerCase().indexOf(tourFilter.search.toLowerCase()) !== -1  ||
               d.info.tourDescription.toLowerCase().indexOf(tourFilter.search.toLowerCase()) !== -1 ||
               d.createdBy?.name?.toLowerCase().indexOf(tourFilter.search.toLowerCase()) !== -1  ||
               d.createdBy?.email?.toLowerCase().indexOf(tourFilter.search.toLowerCase()) !== -1 
               
      );
      setFilterData(filter);
    };
    
    updateFilter(tours);
   
  }, [tours, tourFilter.search]);


  useEffect(() => {

    const sortData = (data) => {
      if(tourFilter.sort !== "") {
          const sorting = data.sort((a,b) => {
            let sortyByKey = tourFilter.sort;
              let fa = a.info[sortyByKey].toLowerCase(),
              fb = b.info[sortyByKey].toLowerCase();

              if (fa < fb) {
                  return -1;
              }
              if (fa > fb) {
                  return 1;
              }
              return 0;
          })
          console.log('after sorting',sorting);
        setFilterData(sorting);
      } 
    }

    sortData([...tours]);
  }, [ tours, tourFilter.sort ]);



  const MapListViewToggle = () => setMapView(!mapView);

  
  return (
    <div className={styles.tourListWraper}>
      <Header />
      <Container fluid="md">
        <TourListHeader text={tourText} description={tourDescription}/>
        
        <TourListFilter toggleMapView={MapListViewToggle} isMapView={mapView} />
        
        { !mapView && 
          <Row>
            {filterData.map((card, idx) => (
              <Col md={6} key={idx}>
                <TourListCard tour={card} />
              </Col>
            ))}
          </Row>
        }
        
        { mapView && 
          <div className={styles.MapViewConatiner}>
            <MapView tours={filterData}></MapView>
          </div>
        }
      </Container>
    </div>
  );
};

export default TourList;
